import { get } from 'lodash';

import { getShopBrand } from '../auth/selectors';
import { canUserUseHandoff } from '../common/helpers/users';
import { isHandoffActive } from '../register/payment/reducer/handoff/selectors';

// eslint-disable-next-line import/prefer-default-export
export const shouldNotifyKioskDevice = (state) => {
  const permissions = state.auth.permissions;
  const brand = getShopBrand(state);
  const isItemizedDisplayEnabled = get(brand, 'settings.itemizedChargeDisplayEnabled', false);
  return isItemizedDisplayEnabled && canUserUseHandoff(permissions) && isHandoffActive(state);
};

export const getKioskSyncCart = state => state.handoff.kioskSyncCart;
